import {
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { useLanguageStore } from "@/stores/language";

interface CartHeaderProps {
  totalItems: number;
}

export const CartHeader = ({ totalItems }: CartHeaderProps) => {
  const { t } = useLanguageStore();

  return (
    <SheetHeader className="flex-shrink-0">
      <SheetTitle>{t("Shopping Cart", "Carrito de Compras")}</SheetTitle>
      <SheetDescription>
        {totalItems === 0 
          ? t("Your cart is empty", "Tu carrito está vacío")
          : t(`${totalItems} item${totalItems !== 1 ? 's' : ''} in your cart`, `${totalItems} artículo${totalItems !== 1 ? 's' : ''} en tu carrito`)}
      </SheetDescription>
    </SheetHeader>
  );
};
